import enUs from './en-us';
import es from './es';
import pt from './pt';
import nl from './nl';

export const langMap = {
    'en-us': enUs,
    en: enUs,
    es,
    pt,
    nl
};

export const messages = Object.keys(enUs).reduce((acc, id) => {
    acc[id] = {
        id,
        description: id,
        defaultMessage: enUs[id]
    };
    return acc;
}, {});

export const langs = (locale) => {
    return langMap[locale] || langMap['en'];
};

export function isLangSupported(locale) {
    return supportedLangs().indexOf(locale) !== -1;
}

export function supportedLangs() {
    return Object.keys(langMap);
}



// WEBPACK FOOTER //
// ./app/lib/i18n/index.js